export const Hashtag = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.29167 3.125L5.625 16.875M14.375 3.125L12.7083 16.875M3.125 6.45833H16.875M16.875 13.5417H3.125"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Hashtag
